"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reducer;
exports.onPhoneNumberValidation = onPhoneNumberValidation;
exports.removeValidation = removeValidation;
exports.resetValidationState = resetValidationState;
exports.updateValidationState = updateValidationState;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _myDataApi = require("../api/myDataApi");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var VALIDATE_PHONENUMBER = 'api/reducer/validation/CHECK_PHONENUMBER';
var VALIDATE_PHONENUMBER_PENDING = 'api/reducer/validation/CHECK_PHONENUMBER_PENDING';
function checkForError(form) {
  var errorValidation = form.validations.find(function (x) {
    return x.hasError === true;
  });
  return errorValidation ? errorValidation.hasError : false;
}
var mergeNewValidation = function mergeNewValidation(formName, inputState, prevState) {
  var newState = JSON.parse(JSON.stringify(prevState));
  if (newState[formName] == null) {
    newState[formName] = {
      formHasError: false,
      validations: [],
      defaultValidations: [],
      resetValidation: false
    };
  }
  var found = false;
  newState[formName].validations.forEach(function (elem, i) {
    if (elem.inputName === inputState.name) {
      newState[formName].validations.splice(i, 1);
      found = true;
    }
  });
  var currentValidationState = {
    inputName: inputState.name,
    hasError: inputState.hasError,
    value: inputState.value ? inputState.value : '',
    id: inputState.id ? inputState.id : '',
    resetValidation: false
  };
  if (!found) {
    newState[formName].defaultValidations.push(_objectSpread(_objectSpread({}, currentValidationState), {}, {
      resetValidation: true
    }));
  }
  newState[formName].validations.push(currentValidationState);
  newState[formName].formHasError = checkForError(newState[formName]);
  return newState;
};
function isPhoneNumberValid(data) {
  return data.valid && (data.type === 'MOBILE' || data.type === 'FIXED_LINE_OR_MOBILE') && data.region === 'DE';
}
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  switch (action.type) {
    case 'validation/reducer/new_validation':
      return mergeNewValidation(action.data.formName, action.data.inputState, state);
    case 'validation/reducer/clear':
      {
        var defaultData = state[action.data.formName].defaultValidations;
        return _objectSpread(_objectSpread({}, state), {}, (0, _defineProperty2.default)({}, action.data.formName, {
          validations: defaultData,
          formHasError: checkForError(state[action.data.formName]),
          defaultValidations: defaultData
        }));
      }
    case 'validation/reducer/remove_validation':
      {
        var newValidations = state[action.data.formName].validations.filter(function (validation) {
          return validation.inputName !== action.data.inputName;
        });
        return _objectSpread(_objectSpread({}, state), {}, (0, _defineProperty2.default)({}, action.data.formName, {
          validations: newValidations,
          formHasError: checkForError(state[action.data.formName]),
          defaultValidations: state[action.data.formName].defaultValidations,
          resetValidation: true
        }));
      }
    case VALIDATE_PHONENUMBER_PENDING:
      {
        return _objectSpread(_objectSpread({}, state), {}, (0, _defineProperty2.default)({}, action.data.formName, {
          phoneNumberValidation: {
            isRequestPending: true
          }
        }));
      }
    case VALIDATE_PHONENUMBER:
      {
        return _objectSpread(_objectSpread({}, state), {}, (0, _defineProperty2.default)({}, action.data.formName, {
          phoneNumberValidation: {
            isRequestPending: false,
            isValid: isPhoneNumberValid(action.data.result.data),
            apiError: action.data.error ? action.data.error : false,
            result: action.data.result.data
          }
        }));
      }
    default:
      return state;
  }
}
function updateValidationState(dispatch, state, formName) {
  dispatch({
    type: 'validation/reducer/new_validation',
    data: {
      formName: formName,
      inputState: state
    }
  });
}
function resetValidationState(dispatch, formName) {
  dispatch({
    type: 'validation/reducer/clear',
    data: {
      formName: formName
    }
  });
}
function removeValidation(dispatch, formName, inputName) {
  dispatch({
    type: 'validation/reducer/remove_validation',
    data: {
      formName: formName,
      inputName: inputName
    }
  });
}
function onPhoneNumberValidation(dispatch, number, formName) {
  dispatch({
    type: VALIDATE_PHONENUMBER_PENDING,
    data: {
      formName: formName
    }
  });
  (0, _myDataApi.validatePhoneNumber)(number).then(function (result) {
    dispatch({
      type: VALIDATE_PHONENUMBER,
      data: {
        formName: formName,
        result: result
      }
    });
  }).catch(function (error) {
    dispatch({
      type: VALIDATE_PHONENUMBER,
      data: {
        formName: formName,
        error: error
      }
    });
  });
}